import { useRef } from "react";
import Nota from "../../../../../Models/Financeiro/Titulo/Nota";
import ModalBase, { IModalBaseProps, ModalBaseRefType } from "../../../../Base/ModalBase";
import NotaFormBasic, { NotaFormInstanceRef } from "./NotaFormBasic";
import { useNotaManter } from "../../../../../Services/Financeiro/Titulo/NotaService";
import { notification } from "antd";
import { PropriedadesDeNotificacao } from "../../../../../Utils/Notificacoes";
import { AxiosResponse } from "axios";

interface INotaFormModalProps extends IModalBaseProps {
    nota:Nota;
    onSuccess?(data: AxiosResponse<void, any>, variables: Nota, context: unknown) : void;
}
export default function NotaFormModal ({
    nota,
    onOk,
    onCancel,
    textButtonOpen,
    onSuccess,
    ...rest
}:INotaFormModalProps) {
    textButtonOpen = textButtonOpen ?? "Editar";

    const refForm = useRef<NotaFormInstanceRef|null>(null);
    const refModal = useRef<ModalBaseRefType|null>(null);

    const {
        mutate,
        isPending
    } = useNotaManter({
        onSuccess(data, variables, context) {
            refModal.current?.fechar();
            notification.success({
                ...PropriedadesDeNotificacao["Sucesso"],
                message : "Nota salva com sucesso."
            });

            onSuccess?.(data, variables, context);
        },
    });

    return <ModalBase
        title={"Gerenciar nota"}
        width={"80vw"}
        ref={refModal}
        onOk={(e) => {
            refForm.current?.submit();
            onOk?.(e);
        }}
        onCancel={(e) => {
            refForm.current?.resetFields();
            refModal.current?.fechar();
            onCancel?.(e);
        }}
        confirmLoading={isPending}
        textButtonOpen={textButtonOpen}
        {...rest}
    >
        <NotaFormBasic 
            onFinish={mutate}
            ref={refForm} 
            nota={nota}
        />
    </ModalBase>;
}